"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var UserDataService = /** @class */ (function () {
    function UserDataService(http) {
        this.http = http;
    }
    UserDataService.prototype.getUsers = function () {
        return this.http.get("/api/user");
    };
    UserDataService.prototype.createUser = function (user) {
        return this.http.post("/api/user", user);
    };
    UserDataService.prototype.updateUser = function (user) {
        return this.http.put("/api/user", user);
    };
    UserDataService.prototype.deleteUser = function (userId) {
        return this.http.delete("/api/user/" + userId);
    };
    UserDataService.prototype.deleteUserData = function (userId) {
        return this.http.delete("/api/user/data/" + userId);
    };
    UserDataService = tslib_1.__decorate([
        core_1.Injectable(),
        tslib_1.__metadata("design:paramtypes", [http_1.HttpClient])
    ], UserDataService);
    return UserDataService;
}());
exports.UserDataService = UserDataService;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci5kYXRhLnNlcnZpY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ1c2VyLmRhdGEuc2VydmljZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2Q0FBa0Q7QUFDbEQsc0NBQTJDO0FBSzNDO0lBRUkseUJBQW9CLElBQWdCO1FBQWhCLFNBQUksR0FBSixJQUFJLENBQVk7SUFDcEMsQ0FBQztJQUVELGtDQUFRLEdBQVI7UUFDSSxPQUE0QixJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxXQUFXLENBQUMsQ0FBQztJQUMzRCxDQUFDO0lBRUQsb0NBQVUsR0FBVixVQUFXLElBQVU7UUFDakIsT0FBMEIsSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsV0FBVyxFQUFFLElBQUksQ0FBQyxDQUFDO0lBQ2hFLENBQUM7SUFFRCxvQ0FBVSxHQUFWLFVBQVcsSUFBVTtRQUNqQixPQUEwQixJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxXQUFXLEVBQUUsSUFBSSxDQUFDLENBQUM7SUFDL0QsQ0FBQztJQUVELG9DQUFVLEdBQVYsVUFBVyxNQUFjO1FBQ3JCLE9BQTBCLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLGVBQWEsTUFBUSxDQUFDLENBQUM7SUFDdEUsQ0FBQztJQUVELHdDQUFjLEdBQWQsVUFBZSxNQUFjO1FBQ3pCLE9BQTBCLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLG9CQUFrQixNQUFRLENBQUMsQ0FBQztJQUMzRSxDQUFDO0lBdkJRLGVBQWU7UUFEM0IsaUJBQVUsRUFBRTtpREFHaUIsaUJBQVU7T0FGM0IsZUFBZSxDQXdCM0I7SUFBRCxzQkFBQztDQUFBLEFBeEJELElBd0JDO0FBeEJZLDBDQUFlIn0=


//////////////////
// WEBPACK FOOTER
// ./src/app/core/user/user.data.service.ts
// module id = 270
// module chunks = 0